<qrcode [qrdata]="qrCodeUrl" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
